import { render, staticRenderFns } from "./DiskErased.vue?vue&type=template&id=1e5934fc&"
import script from "./DiskErased.vue?vue&type=script&lang=js&"
export * from "./DiskErased.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports